import React, { useState, useEffect } from "react"

import { connect } from "react-redux"

import Markers from "../../../media/Images"

import imageMan from "../../../media/images/man.png"

import imageWoman from "../../../media/images/woman.png"

import narantiIcon from "../../../media/images/naranti-icon.png"

import logo from "../../../yt.jpg"

import {
    Button,
    Image,
    List,
    Responsive,
    Header,
    Embed
} from "semantic-ui-react"

import { Modal } from "react-bootstrap"

import { useTranslation } from 'react-i18next';

import {CommonService} from "../../../services/common.service"


function HelpModal(props) {

    const {t} = useTranslation()
    const [open, setOpen] = useState(false)
    const [buttonHidden, setHide] = useState(true)
    const [buttonIcon, setIcon] = useState('eye')
    const [ownMedia, setOwnMedia] = useState(true)
    const [showTutorial, setShowTutorial] = useState(0)
    const [lang, setLang] = useState('');
    
    useEffect(() => {
        const lng = CommonService.getLanguage() === 'es' ? 'es' : 'en';
        setLang(lng);
    }, []);

    const showOwnMedia = () => {
        if (props.media.markersList) {
            setOwnMedia(!ownMedia)
            props.media.markersList.forEach((marker) => {
                let show = false
                if(ownMedia) {
                    setIcon('eye slash')
                    if(marker.code)
                        if (String(marker.code.slice(0, 6)) === String('NAR401'))
                            show = true
                } else {
                    setIcon('eye')
                    show = true
                }
                marker.setVisible(show)
            })
            props.media.mapCircleList.forEach((circle) => {
                let visible = false
                props.media.markersList.forEach((marker) => {
                    if (
                        window.google.maps.geometry.spherical.computeDistanceBetween(
                            marker.getPosition(),
                            circle.getCenter()
                        ) <= circle.getRadius()
                    ) {
                        if (marker.getVisible()) visible = true
                    }
                })
                circle.setVisible(visible)
            })
            props.media.markerClusterer.repaint()
        }
    }

    return (
        <>
            <Responsive maxWidth={499}>
                <Button circular color='orange' icon='help' onClick={() => setOpen(true)}/>
            </Responsive>
            <Responsive minWidth={500}>
                <Button circular color='orange' icon='help' onClick={() => setOpen(true)}/>
            </Responsive>
            
            <Modal
                show={open}
                onHide={() => setOpen(false)}
                scrollable
            >
                <Modal.Header>
                    <Modal.Title onMouseEnter={() => {setHide(false)}} onMouseLeave={() => setHide(true)}>
                        {t("help_modal.help")} <Image src={narantiIcon} size="mini" color="orange" icon={buttonIcon} hidden={buttonHidden} onClick={() => showOwnMedia()}/>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Button.Group>
                        <Button onClick={() => setShowTutorial(0)}>{t("help_modal.tutorial")}</Button>
                        <Button onClick={() => setShowTutorial(1)}>{t("help_modal.elements")}</Button>
                        <Button onClick={() => setShowTutorial(2)}>{t("help_modal.terms_and_conditions")}</Button>
                    </Button.Group>
                    <Embed hidden={showTutorial !== 0}
                        id={lang == 'es' ? `kfpdO6z6bBQ` : `faOQQ42rGyA`}
                        placeholder={logo}
                        source='youtube'
                    />
                    <List verticalAlign="middle" hidden={showTutorial !== 1}>
                        <List.Item>
                            <Image size="mini" src={Markers.azotea} />
                            <List.Content>
                                <List.Header as="h5">
                                    {t("help_modal.billboard")}
                                </List.Header>
                                <List.Description>
                                    {t(`help_modal.locations`)} {t("help_modal.billboard")}
                                </List.Description>
                            </List.Content>
                        </List.Item>
                        <List.Item>
                            <Image size="mini" src={Markers.muro} />
                            <List.Content>
                                <List.Header as="h5">{t("help_modal.wallscapes")}</List.Header>
                                <List.Description>
                                    {t("help_modal.locations")} {t("help_modal.wallscapes")}
                                </List.Description>
                            </List.Content>
                        </List.Item>
                        <List.Item>
                            <Image size="mini" src={Markers.valla} />
                            <List.Content>
                                <List.Header as="h5">{t("help_modal.billboard_poster")}</List.Header>
                                <List.Description>
                                    {t("help_modal.locations")} {t("help_modal.billboard_poster")}
                                </List.Description>
                            </List.Content>
                        </List.Item>
                        <List.Item>
                            <Image size="mini" src={Markers.pantalla} />
                            <List.Content>
                                <List.Header as="h5">{t("help_modal.digital_billboard")}</List.Header>
                                <List.Description>
                                    {t("help_modal.locations")} {t("help_modal.digital_billboard") }
                                </List.Description>
                            </List.Content>
                        </List.Item>
                        <List.Item>
                            <Image size="mini" src={Markers.landmark} />
                            <List.Content>
                                <List.Header as="h5">{t("help_modal.landmark")}</List.Header>
                                <List.Description>
                                    {t("help_modal.locations")} {t("help_modal.landmark")}
                                </List.Description>
                            </List.Content>
                        </List.Item>
                        <List.Item>
                            <Image size="mini" src={Markers.parabus} />
                            <List.Content>
                                <List.Header as="h5">{t("help_modal.oppis")}</List.Header>
                                <List.Description>
                                    {t("help_modal.locations")} {t("help_modal.oppis")}
                                </List.Description>
                            </List.Content>
                        </List.Item>
                        <List.Item>
                            <Image
                                size="mini"
                                src={Markers["puente peatonal"]}
                            />
                            <List.Content>
                                <List.Header as="h5">
                                    {t("help_modal.pedestrian_bridge_advertising")}
                                </List.Header>
                                <List.Description>
                                    {t("help_modal.locations")} {t("help_modal.pedestrian_bridge_advertising")}
                                </List.Description>
                            </List.Content>
                        </List.Item>
                        <List.Item>
                            <Image
                                size="mini"
                                src={Markers["valla digital"]}
                            />
                            <List.Content>
                                <List.Header as="h5">
                                    {t("help_modal.digital_billboard_poster")}
                                </List.Header>
                                <List.Description>
                                    {t("help_modal.locations")} {t("help_modal.digital_billboard_poster")}
                                </List.Description>
                            </List.Content>
                        </List.Item>
                        <List.Item>
                            <Image size="mini" src={Markers.mediaGroup} />
                            <List.Content>
                                <List.Header as="h5">
                                    {t("help_modal.media_grouping")}
                                </List.Header>
                                <List.Description>
                                    <Responsive maxWidth={499}>
                                        <p title={t("help_modal.media_grouping")}>
                                            {t("help_modal.represents_the_locations_of_various_media_in_the_same_site")}
                                        </p>
                                    </Responsive>
                                    <Responsive minWidth={500}>
                                        <p>
                                            {t("help_modal.represents_the_locations_of_various_media_in_the_same_site")}
                                        </p>
                                    </Responsive>
                                </List.Description>
                            </List.Content>
                        </List.Item>
                    </List>
                    <div hidden={showTutorial !== 2} style={{ textAlign: "justify", paddingTop: "10px" }}>
                        <Header as="h1" textAlign="center">
                            Términos y Condiciones de Uso de la herramienta digital denominada “Mapa Naranti”
                        </Header>
                        <p><strong>Fecha de última actualización:</strong> 07 de mayo de 2025.</p>

                        <p>Bienvenido a <a href="https://www.naranti.com">www.naranti.com</a>. al acceder o utilizar nuestra herramienta denominada “Mapa Naranti”, en nuestro sitio web, ubicado en [https://naranti.com/ooh/], aceptas cumplir con los siguientes Términos y Condiciones de Uso. Si no está de acuerdo con ellos, por favor no utilice la herramienta.</p>

                        <Header as="h2">1. Descripción del Servicio</Header>
                        <p>Naranti México ofrece una herramienta digital gratuita que permite a los usuarios:</p>
                        <ul>
                            <li>Visualizar un mapa interactivo con ubicaciones y disponibilidad de espacios publicitarios que Naranti México comercializa en México y Latinoamérica.</li>
                            <li>Seleccionar uno o más espacios para armar una campaña publicitaria.</li>
                            <li>Añadir al carrito la selección de espacios publicitarios de su interés,  para recibir una <strong>cotización personalizada</strong>  por parte de un ejecutivo de cuenta a más tardar dentro de los próximos 03 tres días hábiles siguientes al envío de la solicitud. </li>
                        </ul>
                        <p><strong>Importante:</strong> Esta plataforma <strong>no permite la contratación ni pago en línea.</strong> Todas las cotizaciones y contrataciones son gestionadas posteriormente por un representante de nuestra empresa.</p>

                        <Header as="h2">2. Uso Aceptable</Header>
                        <p>Al usar nuestro sitio, usted se compromete a:</p>
                        <ul>
                            <li>Usar la plataforma para cotizar campañas publicitarias, que posteriormente puedan ser contratadas por medio de Naranti México, toda contratación que se realice por medio de terceros no serán responsabilidad de Naranti México ni de sus filiales.</li>
                            <li>No copiar, distribuir o explotar el contenido del sitio sin autorización escrita.</li>
                            <li>No interferir con el funcionamiento del sitio ni intentar acceder a sistemas internos sin autorización.</li>
                        </ul>

                        <Header as="h2">3. Registro y Datos Personales</Header>
                        <p>Puede usar el sitio sin registrarse, pero para solicitar una cotización es posible que debas proporcionar información como:</p>
                        <ul>
                            <li>Nombre completo</li>
                            <li>Empresa</li>
                            <li>Correo electrónico</li>
                            <li>Número de contacto</li>
                        </ul>
                        <p>Nos comprometemos a tratar tus datos personales conforme a nuestro Aviso de Privacidad disponible en <a href="https://naranti.com/mx/es/aviso-de-privacidad" target="_blank" rel="noreferrer">https://naranti.com/mx/es/aviso-de-privacidad</a></p>

                        <Header as="h2">4. Propiedad Intelectual</Header>
                        <p>Todo el contenido del sitio, incluyendo pero no limitado a mapas, diseño, texto, gráficos y software, es propiedad de Naranti México, SA de CV, y está protegido por leyes de derechos de autor y propiedad industrial.</p>

                        <Header as="h2">5. Limitación de Responsabilidad</Header>
                        <ul>
                            <li>La información en el mapa es referencial y está sujeta a disponibilidad.</li>
                            <li>No garantizamos que las ubicaciones seleccionadas estén disponibles al momento de la solicitud hasta que un ejecutivo de cuenta así lo confirme.</li>
                            <li>No nos hacemos responsables por interrupciones en el servicio, errores técnicos o falta de acceso temporal. Sin embargo trataremos de restablecer el uso de la plataforma lo más pronto posible una vez que se reporte la falla por medio de correo electrónico a <a href="mailto:soporte@naranti.com.mx">soporte@naranti.com.mx</a>.</li>
                        </ul>

                        <Header as="h2">6. Enlaces a Terceros</Header>
                        <p>El sitio puede contener enlaces a sitios web de terceros. No tenemos control sobre estos sitios y no somos responsables por su contenido o políticas.</p>

                        <Header as="h2">7. Modificaciones</Header>
                        <p>Nos reservamos el derecho de actualizar o modificar estos Términos en cualquier momento. Los cambios se considerarán aceptados si continúas usando el sitio después de su publicación.</p>

                        <Header as="h2">8. Legislación Aplicable</Header>
                        <p>Estos Términos se rigen por las leyes de México. Cualquier disputa será resuelta ante los tribunales competentes de dicha jurisdicción. Tratándose de ubicaciones contratadas fuera del territorio mexicano, las disputas que se originen por dichas contrataciones, podrán ser resueltas por medio de arbitraje comercial internacional.</p>

                        <Header as="h2">9. Contacto</Header>
                        <p>Para cualquier consulta relacionada con estos Términos, puedes contactarnos en:</p>
                        <ul>
                            <li>Email: <a href="mailto:compliance@naranti.com.mx">compliance@naranti.com.mx</a> / <a href="mailto:legal@naranti.com.mx">legal@naranti.com.mx</a></li>
                            <li>Teléfono: +52 443 2741515</li>
                        </ul>
                    </div>
                    <Header as="h5" textAlign="center">
                        {t("help_modal.contact_advisor")}
                    </Header>
                    <List
                        verticalAlign="top"
                        style={{ textAlign: "center" }}>
                        <List.Item>
                            <Image
                                avatar
                                src={
                                    props.media.currentExecutive.gender === "M"
                                        ? imageMan
                                        : imageWoman
                                }
                            />
                            <List.Content>
                                <List.Header
                                    href={`tel:+52${props.media.currentExecutive.phone}`}
                                    as="a">
                                    {/* {`${props.media.currentExecutive.name}`} */}
                                </List.Header>
                                <List.Description>
                                    <p>
                                        <Button
                                            as='a'
                                            circular 
                                            color='green' 
                                            size='mini' 
                                            icon={{name: 'whatsapp', size:'big'}} 
                                            target='_blank'
                                            href={`
                                                https://wa.me/52${props.media.currentExecutive.officePhoneNumber}?text=${t("main.whastapp_text")}
                                            `}
                                        />
                                    </p>
                                </List.Description>
                            </List.Content>
                        </List.Item>
                    </List>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        color="black"
                        onClick={() => setOpen(false)}
                        className="mr-auto"
                        content={t("help_modal.close")}
                    />
                    <Button
                        as="a"
                        color="green"
                        icon="phone"
                        labelPosition="right"
                        content={t("help_modal.call_advisor")}
                        href={`tel:+52${props.media.currentExecutive.phone}`}
                    />
                </Modal.Footer>
            </Modal>
        </>
    )
}

const mapStateToProps = state => ({ media: state.media })

export default connect(mapStateToProps)(HelpModal)
